import { FC } from 'react';
import { Bar } from 'react-chartjs-2';
import { BarElement, CategoryScale, Chart as ChartJS, ChartOptions, LinearScale } from 'chart.js';

import { COLORS } from '@/shared/constants/colors';
import { numbers } from '@/shared/utils/numbers';

ChartJS.register(CategoryScale, LinearScale, BarElement);

type BarStackedChartProps = {
  items: Array<number>;
  labels: Array<string>;
};

export const BarStackedChart: FC<BarStackedChartProps> = ({ items, labels: externalLabels }) => {
  const options: ChartOptions<'bar'> = {
    indexAxis: 'y' as const,
    responsive: true,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
        display: false,
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        },
        display: false,
      },
    },

    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: ({ datasetIndex }) => {
            return `${externalLabels[datasetIndex]}: ${numbers.formatPercent({
              value: items[datasetIndex],
              withSign: true,
            })}`;
          },
        },
      },
    },
  };

  const labels = ['Assets'];

  const data = {
    labels,
    datasets: items?.map((item, index) => ({
      label: externalLabels[index] || '',
      data: labels.map(() => item),
      backgroundColor: COLORS.chartColors[index],
    })),
  };

  return <Bar options={options} data={data} height={50} />;
};
